const I18N_ASSETS_PATH = '/i18n';

export function translationsAsset(language: string): string {
  return `${I18N_ASSETS_PATH}/${language}.json`;
}
